'use client'

import { ReactNode } from 'react'

import { DataProvider } from '@/shared/contexts/DataContext'
import { ModalProvider } from '@/shared/contexts/Modal'
import { UserProgressProvider } from '@/shared/contexts/UserProgress'
import { API_PATHS } from '@/shared/lib/data/paths'
import type { InitialUserData } from '@/shared/lib/data/types'
import { BootstrapGate } from '@/shared/ui/BootstrapGate'
import { DataInitializer } from '@/shared/ui/DataInitializer'
type DataProvidersProps = {
  initialData: InitialUserData
  children: ReactNode
}

export function DataProviders({ initialData, children }: DataProvidersProps) {
  const initialUserProgress =
    initialData[API_PATHS.USER_PROGRESS]?.record ?? null
  const initialBootstrap = initialData[API_PATHS.DATA]?.record ?? null

  return (
    <DataProvider initialData={initialData}>
      <UserProgressProvider initialData={initialUserProgress}>
        <ModalProvider>
          <DataInitializer initialData={initialBootstrap} />
          <BootstrapGate initialBootstrap={initialBootstrap}>
            {children}
          </BootstrapGate>
        </ModalProvider>
      </UserProgressProvider>
    </DataProvider>
  )
}
